// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"PostingInfo__materialize-textarea___vFS8w","modal-2463794813":"PostingInfo__modal-2463794813___2WXxu","container":"PostingInfo__container___3iGkJ","videoHeader":"PostingInfo__videoHeader___2XZIc","mainHeader":"PostingInfo__mainHeader___2pUii","lightText":"PostingInfo__lightText___2IjIp","removePadding":"PostingInfo__removePadding___2fbDQ","inputFields":"PostingInfo__inputFields____LPsv","buttonContainer":"PostingInfo__buttonContainer___2ElIh","infoButton":"PostingInfo__infoButton___3ZXKv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PostingInfo/PostingInfo.scss
// module id = 1513
// module chunks = 0